/**
 * The words around a holding's return in the display currency.
 *
 * docs/specs/2026-10-24-holding-returns-in-display-currency-design.md §4.
 */

const signed = (n) => `${n > 0 ? '+' : n < 0 ? '−' : ''}${Math.abs(n).toFixed(2)}`;

/**
 * The % pill's tooltip for a return that was converted: the return in the
 * holding's own currency, how many points the exchange rate took or added,
 * and that a dividend counts on the broker. Null when nothing was converted.
 * `ret` is a holding's row, or a broker's (whose `own` lists its currencies).
 */
export function holdingReturnNote(ret, t) {
  if (!ret || ret.currency_effect_pts == null) return null;
  const own = ret.own_currency
    ? { currency: ret.own_currency, pct: ret.own_pct }
    : (ret.own || [])[0];
  if (!own || own.pct == null) return null;
  return [
    t('accounts:sub.returnInOwn', { currency: own.currency, pct: `${signed(own.pct)}%` }),
    t('accounts:sub.returnRateShare', { pts: signed(ret.currency_effect_pts) }),
    t('accounts:sub.returnPriceOnly'),
  ].join(' · ');
}

/** "since bought", or the range's own label ("over 1Y"). */
export function returnRangeLabel(range, t) {
  return !range || range === 'ALL' ? t('accounts:sub.sinceBought') : t('accounts:sub.overRange', { range });
}
